// extracted by mini-css-extract-plugin
export var artists = "ArtistsContainer-module--artists--JC3d6";